import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";

const UserList = () => {

    const { t } = useTranslation();
    return (
        <ListPage
            showPageTitle="true"
            activeMenu={t("users")}
            motherMenu={t("identity")}
            path={Api.identity.user}
            route={MenuConfig.identity.user.route}
            columns={Columns}
        />
    );
}

export default UserList;